import {
  Field,
  IconOrder,
  Modal,
  SecondaryButton,
  Space,
  TertiaryButton,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useFinancialAccountStatementDownload } from './useFinancialAccountStatementDownload'
import { StatementPeriodSelect } from '../../components/StatementPeriodSelect'
import { DownloadFinancialAccountStatementPresenter } from '../../features/download-financial-account-statement/presenters/DownloadFinancialAccountStatementPresenter'

export interface IFinancialAccountStatementDownloadProps {
  financialAccountId: Nullable<number>
}

const STATEMENT_PERIOD_SELECT_ID = 'statement-period-select'

export const FinancialAccountStatementDownload = ({
  financialAccountId,
}: IFinancialAccountStatementDownloadProps) => {
  const intl = useProcurifyIntl()

  const {
    data: { selectedPeriod },
    methods: { setSelectedPeriod },
    commands: { openModal, closeModal },
    states: { isModalOpen },
  } = useFinancialAccountStatementDownload()

  if (!financialAccountId) return null

  return (
    <>
      <SecondaryButton iconComponent={<IconOrder />} onClick={openModal}>
        {intl.formatMessage(messages.statementsButtonText)}
      </SecondaryButton>

      <Modal open={isModalOpen} onClose={closeModal}>
        <Modal.Card>
          <Modal.Header onClose={closeModal}>
            {intl.formatMessage(messages.modalHeaderText)}
          </Modal.Header>

          <Modal.Content>
            <Space>
              <Space direction='horizontal'>
                <Space.Item width={200}>
                  <Field
                    label={intl.formatMessage(messages.statementSelectLabel)}
                    labelFor={STATEMENT_PERIOD_SELECT_ID}
                  >
                    <StatementPeriodSelect
                      inputId={STATEMENT_PERIOD_SELECT_ID}
                      financialAccountId={financialAccountId}
                      value={selectedPeriod}
                      onChange={setSelectedPeriod}
                    />
                  </Field>
                </Space.Item>
              </Space>

              <Space.Divider />

              <Space direction='horizontal' justify='end'>
                <TertiaryButton type='button' onClick={closeModal}>
                  {intl.formatMessage(messages.cancelButtonText)}
                </TertiaryButton>

                <DownloadFinancialAccountStatementPresenter
                  financialAccountId={financialAccountId}
                  datePeriod={selectedPeriod}
                  onSuccess={closeModal}
                />
              </Space>
            </Space>
          </Modal.Content>
        </Modal.Card>
      </Modal>
    </>
  )
}

FinancialAccountStatementDownload.displayName =
  'FinancialAccountStatementDownload'
